import { UserTypes } from 'types/GlobalTypes';

export const StatusCodes = {
  Success: 200,
  BadRequest: 400,
  Unauthorized: 401,
  NotFound: 404,
  InternalServerError: 500,
};

export const TypeColorsDictionary: Record<UserTypes | string, string> = {
  admin: 'black',
  analyst: 'dark-periwinkle',
  scout: 'kermit-green',
  trainer: 'ballPlayerBLue',
  coach: 'sky-blue',
  player: 'orange',
  stadiumtagger: 'stadiumTagger',
  cloudlivedashboard: 'cloudLiveDashboard',
  user: 'reddish-pink',
  other: 'reddish-pink',

  // status
  active: 'success',
  pending: 'primary',
  pendinguseraction: 'primary',
  pendingappsetup: 'primary',
  pendingemailsend: 'primary',
  inactive: 'secondary',
  abandoned: 'secondary',
  finalized: 'black',
};

export const PITCHING = 'Pitching';
export const HITTING = 'Hitting';
export const METRIC = 'Metric';
export const IMPERIAL = 'Imperial';

export const FLAGS_ARRAY: string[] = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789?!*#$@+-:/^%'.split('');

export const ServiceTypes = {
  ErrorHandler: Symbol('ErrorHandler'),
  ConfigurationService: Symbol('ConfigurationService'),
  AuthenticationService: Symbol('AuthenticationService'),
  apiServiceAxiosInstance: Symbol('apiServiceAxiosInstance'),
};

// Set to true when the Player Performance tab should appear in the navigation.
// When false the tab is hidden from the menu but the route still works — users
// who know the URL can still navigate to it directly.
export const PLAYER_PERFORMANCE_TAB_VISIBLE = false;

// Permission names are written without the token's `@app` app-scope suffix
// (e.g. `@FB`, `@FBTP`). IsAllowed compares on the bare name and ignores the suffix,
// so the same permission is honoured regardless of which app it was scoped to —
// matching how the backend authorizes on the suffix-less permission name.
export const AppPermissions = {
  PortalAccess: 'FB.TeamPortalAccess',
  UserManagementAccess: 'FBS.ManageUsers',
  ClientsManagementAccess: 'FBS.ManageDataIntegrationClients',
  OrgReportsAccess: 'FBTP.Read.DataSnapshot.MyOrganization',
};

export const AppLinks = {
  About: 'https://login.trackman.com/Home/About',
  Terms: 'https://login.trackman.com/Home/TermsAndConditions',
  Support: 'https://trackman.zendesk.com/hc/en-us',
  Contact: 'https://support.trackman.com/hc/en-us',
  // Social
  Facebook: 'https://www.facebook.com/TrackManBB',
  Twitter: 'https://twitter.com/TrackManBB',
  LinkedIn: 'https://www.linkedin.com/company/trackman-',
};
